'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var ComponentProvider = require('../../providers/ComponentProvider.js');

const ComponentInsertion = _ref => {
  var _components$area;
  let {
    area,
    position
  } = _ref;
  const components = React.useContext(ComponentProvider.ComponentContext);
  if (!area || !position) return null;
  const newElm = components === null || components === void 0 ? void 0 : (_components$area = components[area]) === null || _components$area === void 0 ? void 0 : _components$area[position];
  return /*#__PURE__*/React.isValidElement(newElm) ? newElm : null;
};

exports["default"] = ComponentInsertion;
